import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-flexbox-grid";
import styled from "styled-components";

import GuidesTabCell from "../../molecules/GuidesTabPages/GuidesTabCell";
import { executeGhostApi, generateImageUrl } from "../../../helpers/ghost";
import StyledLoading from "../Loading/StyledLoading";
import PageMeta from "../../molecules/PageMeta";
import urlPatterns from "../../../urls";
import GuidesSearchField from "../GuidesSearchField";

const RowContainer = styled(Row)`
  padding: 0 0 40px 0;
`;

class GuidesPosts extends Component {
  static propTypes = {
    history: PropTypes.shape({
      push: PropTypes.func,
    }).isRequired,
    filters: PropTypes.string.isRequired,
    metaTitle: PropTypes.string,
    metaDescription: PropTypes.string,
    posts: PropTypes.arrayOf(PropTypes.shape({})),
    isFromTabGrape: PropTypes.bool,
    isFromTabMore: PropTypes.bool,
    isFromTabAll: PropTypes.bool,
    isFromTabRegion: PropTypes.bool,
    isFromTabTasting: PropTypes.bool,
    location: PropTypes.shape({}).isRequired,
  };

  static defaultProps = {
    metaTitle: "Wine 101 For Beginners: Learn About Wine | Good Pair Days",
    metaDescription: null,
    posts: [],
    isFromTabGrape: false,
    isFromTabMore: false,
    isFromTabAll: false,
    isFromTabRegion: false,
    isFromTabTasting: false,
  };

  state = {
    loading: true,
    posts: [],
    searchText: "",
  };

  async componentDidMount() {
    const { filters, posts } = this.props;
    if (posts && posts.length > 0) {
      this.setState({ posts, loading: false });
    } else {
      const fetchedPosts = await executeGhostApi(filters);
      this.setState({ posts: fetchedPosts, loading: false });
    }
  }

  /**
   * This function handles the change from the guides list view to details of the guide post.
   *
   * @param {Object} post
   * @returns {String}
   * */
  openPageDetails = (post) => {
    const { isFromTabGrape, isFromTabMore, isFromTabAll, isFromTabRegion, isFromTabTasting } = this.props;
    // eslint-disable-next-line camelcase
    const { slug, tags, primary_tag } = post || {};
    const [primaryTag, secondaryTag] = tags || [];
    if (isFromTabGrape) {
      if (secondaryTag && primary_tag.slug === primaryTag.slug) {
        // CASE: when an item has secondary tag, means it has children,
        // so, we navigate and show children posts of the clicked item.
        return `${urlPatterns.GUIDE_GRAPE_COLOR_GLOSSARY(secondaryTag.slug)}`;
      }

      // CASE: when an item doesnt have secondary tag, we navigate to show post details.
      return `${urlPatterns.GUIDE_GRAPE_COLOR_POST(slug)}`;
    }
    if (isFromTabMore) {
      if (secondaryTag && primary_tag.slug === primaryTag.slug) {
        return `${urlPatterns.GUIDE_MORE_GLOSSARY(secondaryTag.slug)}`;
      }
      return `${urlPatterns.GUIDE_MORE_POST(slug)}`;
    }
    if (isFromTabAll) {
      if (secondaryTag && primary_tag.slug === primaryTag.slug) {
        return `${urlPatterns.GUIDE_101_GLOSSARY(secondaryTag.slug)}`;
      }
      return `${urlPatterns.GUIDE_101_POST(slug)}`;
    }
    if (isFromTabRegion) {
      if (secondaryTag && primary_tag.slug === primaryTag.slug) {
        return `${urlPatterns.GUIDE_REGION_GLOSSARY(secondaryTag.slug)}`;
      }
      return `${urlPatterns.GUIDE_REGION_POST(slug)}`;
    }
    if (isFromTabTasting) {
      if (secondaryTag && primary_tag.slug === primaryTag.slug) {
        return `${urlPatterns.GUIDE_TASTING_GLOSSARY(secondaryTag.slug)}`;
      }
      return `${urlPatterns.GUIDE_TASTING_POST(slug)}`;
    }
    return `${urlPatterns.GUIDE_101}`;
  };

  /**
   * This function filters any general grape type (i.e. Red, White, Sparkling),
   * ...and only returns specific grape type (i.e. Syrah, Moscato, Pinot Gris) .
   * */
  filterPosts = () => {
    const { posts } = this.state;
    const { filters } = this.props;
    const filteredPosts = posts.filter((item) => item.primary_tag.slug === filters);
    return filteredPosts;
  };

  /**
   * Handles the event when text is typed on search field.
   *
   * @param {String} value
   * */
  handleSearchInput = (value) => {
    this.setState({ searchText: value });
  };

  /**
   * Handles the event when Enter button is clicked on search field.
   *
   * @param {Object} event
   * */
  handleSubmitOnEnter = (event) => {
    const { history, location } = this.props;
    const { search } = location || {};
    const { key } = event;
    const { searchText } = this.state;
    if (key === "Enter") {
      history.push({
        pathname: urlPatterns.GUIDE_SEARCH_ARTICLES,
        state: { searchText },
        search,
      });
    }
  };

  render() {
    const { metaTitle, metaDescription, location } = this.props;
    const { loading, searchText } = this.state;

    if (loading) {
      return <StyledLoading />;
    }

    const posts = this.filterPosts();

    return (
      <>
        <PageMeta title={metaTitle} description={metaDescription} location={location} />
        <RowContainer>
          <Col md={8} lg={9}>
            {!loading &&
              posts &&
              posts.map((post) => (
                <Fragment key={`${post.id}`}>
                  <GuidesTabCell
                    title={post.title}
                    description={post.excerpt}
                    id={`${post.id}`}
                    image={post.feature_image ? generateImageUrl(post.feature_image) : ""}
                    isGlossary={post.tags && post.tags.length > 1}
                    toUrlLink={this.openPageDetails(post)}
                    location={location}
                  />
                </Fragment>
              ))}
          </Col>
          <Col md={4} lg={3}>
            <GuidesSearchField
              onChange={this.handleSearchInput}
              onKeyPress={this.handleSubmitOnEnter}
              value={searchText}
              location={location}
            />
          </Col>
        </RowContainer>
      </>
    );
  }
}

export default GuidesPosts;
